export const BUSINESS = {
  name: "Abid Home Solutions",
  legalName: "Abid Home Solutions LLC",
  logo: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/msk9c2ol_logo.png",
  slogan: "Quality Work. Fair Pricing. Clean Results.",
  shortArea: "Handyman services in Montgomery County & the DMV.",
  tagline:
    "Professional handyman services for TV mounting, furniture assembly, fitness equipment assembly, appliance installation, curtain installation, picture and mirror hanging, playground assembly, moving help, basic repairs, and home maintenance across Montgomery County and the DMV.",
  phone: "(227) 277-2112",
  phoneHref: "tel:2272772112",
  smsHref: "sms:2272772112",
  email: "abidhomesolutions@gmail.com",
  emailHref: "mailto:abidhomesolutions@gmail.com",
  serviceArea:
    "Montgomery County, Frederick, Washington, DC, McLean, Alexandria, and nearby areas within 30 miles of 20878.",
  serviceCities: [
    "Montgomery County",
    "Frederick",
    "Washington, DC",
    "McLean",
    "Alexandria",
    "Gaithersburg (20878)",
  ],
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/reviews", label: "Reviews" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export const TRUST_BADGES = [
  "Fast Response",
  "Free Estimates",
  "5-Star Customer Reviews",
  "Fair Pricing",
  "Clean & Tidy Work",
  "Local Home Services",
];

export const WHY_CHOOSE = [
  { title: "Fast Response Times", desc: "Quick replies so your project doesn't wait." },
  { title: "Free Estimates", desc: "Tell us about your job — no commitment required." },
  { title: "Fair & Honest Pricing", desc: "Straightforward quotes with no surprises." },
  { title: "5-Star Customer Reviews", desc: "Trusted by local homeowners and renters." },
  { title: "Clean & Tidy Work", desc: "We leave your space cleaner than we found it." },
  { title: "Respectful Service", desc: "Friendly, professional, on time." },
  { title: "Flexible Scheduling", desc: "Evenings and weekends available." },
  { title: "Local Service Area", desc: "Serving Montgomery County, Frederick, DC, and nearby." },
  { title: "Careful Handling", desc: "Your home and belongings treated with care." },
  { title: "Professional Communication", desc: "Clear updates from request to completion." },
];

// homePreview=true → shown in Home preview (6 cards). All services show on /services.
const img = (id) =>
  `https://images.unsplash.com/photo-${id}?w=1200&auto=format&fit=crop&q=80`;

// Lazy import-safe local helper duplicate so this module stays pure data.
function ph(label) {
  const text = decodeURIComponent(label)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"><defs><linearGradient id="b" x1="0" x2="1" y1="0" y2="1"><stop offset="0" stop-color="#172033"/><stop offset="1" stop-color="#0f172a"/></linearGradient><pattern id="d" width="22" height="22" patternUnits="userSpaceOnUse"><circle cx="1.2" cy="1.2" r="1.2" fill="#ffffff" fill-opacity="0.06"/></pattern></defs><rect width="800" height="600" fill="url(#b)"/><rect width="800" height="600" fill="url(#d)"/><text x="400" y="320" text-anchor="middle" fill="#ffffff" font-family="sans-serif" font-size="34" font-weight="800">${text}</text><text x="400" y="360" text-anchor="middle" fill="#ffffff" fill-opacity="0.6" font-family="sans-serif" font-size="16">Real project photo coming soon</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export const SERVICES = [
  {
    slug: "tv-mounting",
    title: "TV Mounting",
    icon: "Tv",
    homePreview: true,
    short:
      "Professional TV mounting for all TV sizes and wall types, including drywall, brick, concrete, and more.",
    bullets: [
      "All TV sizes",
      "Drywall, brick, concrete, and other wall types",
      "Clean and level installation",
      "Wire management options when available",
    ],
    image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/h1q4mjd6_tv.jpe",
    fallbackLabel: "TV Mounting",
    category: "TV Mounting",
  },
  {
    slug: "furniture-assembly",
    title: "Furniture Assembly",
    icon: "Hammer",
    homePreview: true,
    short:
      "Furniture assembly for IKEA, Wayfair, Amazon, and other major retailers, including beds, dressers, desks, tables, cabinets, shelves, and more.",
    bullets: [
      "IKEA, Wayfair, Amazon, and more",
      "Beds, dressers, desks, tables, cabinets, shelves",
      "Bedroom, office, living room, and outdoor furniture",
      "Careful, efficient, and clean assembly",
    ],
    image: img("1505693416388-ac5ce068fe85"),
    fallbackLabel: "Furniture Assembly",
    category: "Furniture Assembly",
  },
  {
    slug: "fitness-equipment-assembly",
    title: "Fitness Equipment Assembly",
    icon: "Dumbbell",
    homePreview: true,
    short:
      "Assembly for treadmills, ellipticals, exercise bikes, weight benches, home gyms, basketball hoops, and other fitness equipment.",
    bullets: [
      "Treadmills, ellipticals, and exercise bikes",
      "Weight benches and home gyms",
      "Basketball hoops",
      "Careful setup and testing",
    ],
    image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/cvoe2wyl_image.png",
    fallbackLabel: "Fitness Equipment Assembly",
    category: "Fitness Equipment",
  },
  {
    slug: "appliance-installation",
    title: "Appliance Installation",
    icon: "Plug",
    homePreview: true,
    short:
      "Installation help for washers, dryers, microwaves, dishwashers, and other common household appliances.",
    bullets: [
      "Washers and dryers",
      "Microwaves",
      "Dishwashers",
      "Careful setup and cleanup",
    ],
    image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/cv4rfjhp_ChatGPT%20Image%20May%2017%2C%202026%2C%2012_09_22%20AM.png",
    fallbackLabel: "Appliance Installation",
    category: "Appliance Installation",
  },
  {
    slug: "curtain-picture-mirror-hanging",
    title: "Curtain, Picture & Mirror Hanging",
    icon: "Frame",
    homePreview: true,
    short:
      "Curtain rod installation, picture hanging, artwork hanging, mirror hanging, and secure wall mounting.",
    bullets: [
      "Curtain rod installation",
      "Picture and artwork hanging",
      "Mirror hanging",
      "Level and secure placement",
    ],
    image: img("1616486338812-3dadae4b4ace"),
    fallbackLabel: "Curtain, Picture & Mirror Hanging",
    category: "Curtain, Picture & Mirror Hanging",
  },
  {
    slug: "play-equipment-assembly",
    title: "Play Equipment Assembly",
    icon: "TreePine",
    homePreview: true,
    short:
      "Assembly for trampolines, playsets, playhouses, basketball hoops, playground equipment, and similar outdoor play equipment.",
    bullets: [
      "Trampolines",
      "Playsets and playhouses",
      "Basketball hoops",
      "Playground equipment",
      "Outdoor play assembly projects",
    ],
    image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/c3j4zosy_IMG_1709.JPEG",
    fallbackLabel: "Play Equipment Assembly",
    category: "Play Equipment",
  },
  {
    slug: "moving-help",
    title: "Moving Help",
    icon: "Truck",
    homePreview: false,
    short:
      "Loading, unloading, furniture moving, heavy item moving, and rearranging items around the home.",
    bullets: [
      "Loading and unloading",
      "Heavy item moving",
      "Furniture moving",
      "Careful handling of belongings",
    ],
    image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/7piygeme_ChatGPT%20Image%20May%2017%2C%202026%2C%2012_12_22%20AM.png",
    fallbackLabel: "Moving Help",
    category: "Moving Help",
  },
  {
    slug: "basic-repairs-maintenance",
    title: "Home Repairs & Maintenance",
    icon: "Wrench",
    homePreview: false,
    short:
      "Small repairs and general maintenance around the house, including fixing, tightening, adjusting, replacing, and basic handyman help.",
    bullets: [
      "Basic home repairs",
      "Small maintenance tasks",
      "Tightening, fixing, adjusting, replacing",
      "General handyman help",
    ],
    image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/wcjdhaag_ChatGPT%20Image%20May%2017%2C%202026%2C%2012_15_13%20AM.png",
    fallbackLabel: "Home Repairs & Maintenance",
    category: "Repairs & Maintenance",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Request a Free Estimate",
    desc:
      "Fill out a quick form and tell us what service you need. There is no commitment required. You can include project details and upload photos so we can better understand the work.",
  },
  {
    n: "02",
    title: "Quick Call or Text Consultation",
    desc:
      "After receiving your request, we will schedule a quick 5-minute call or continue the conversation over text to confirm the details, answer questions, review pricing, and find a time that works for you.",
  },
  {
    n: "03",
    title: "Schedule, Show Up, and Get It Done",
    desc:
      "Once everything is confirmed, we schedule a convenient appointment, arrive on time, complete the work professionally, and leave your space clean and tidy.",
  },
];

export const REVIEWS = [
  {
    name: "AJ",
    service: "Playground Assembly & Installation",
    text:
      "Reached out to Abid Home Solutions to put together and install our playground. They did a phenomenal job. Very professional and responsive. They were honest about the timeframe and the amount of work involved. Pricing was very fair for the amount of work. We even had them work on another project for us afterward. I'm sure we will reach out again for more projects around the house. Highly recommend!",
  },
  {
    name: "Cindy G.",
    service: "Fitness Equipment Assembly / Basketball Hoop Repair",
    text:
      "Wonderful job repairing my son's basketball hoop. They went above and beyond and explained the repair clearly. Punctual, quick to respond, and very professional. I would definitely use them again.",
  },
  {
    name: "Musa K.",
    service: "Furniture Assembly",
    text:
      "I had a great experience with Abid Home Solutions. They helped assemble multiple furniture pieces from both IKEA and Wayfair, and the results were perfect. The team was flexible with scheduling, arrived on time, and worked efficiently and professionally. It's rare to find a service that is both reliable and high-quality, but Abid Home Solutions nailed it. I'll definitely be using them again and recommending them to friends and family. Thank you for making a potentially stressful task so easy!",
  },
  {
    name: "Hadja B.",
    service: "Furniture Assembly",
    text:
      "They were a few dollars more than other options, but they were quick to respond and completed the job the same day with high-quality work. They will likely be my first call for the next job.",
  },
];

export const GALLERY_CATEGORIES = [
  "All",
  "TV Mounting",
  "Furniture Assembly",
  "Fitness Equipment",
  "Appliance Installation",
  "Curtain, Picture & Mirror Hanging",
  "Play Equipment",
  "Moving Help",
  "Repairs & Maintenance",
];

export const GALLERY_ITEMS = [
  { label: "TV Mounting — Living Room", category: "TV Mounting", image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/kyff8rms_IMG_2626%202.JPEG" },
  { label: "TV Mounting with Soundbar", category: "TV Mounting", image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/yidtixsv_IMG_4180%203.JPG" },
  { label: "Backyard Playset", category: "Play Equipment", image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/6uo4psp6_IMG_3510.jpg" },
  { label: "Wooden Playset Install", category: "Play Equipment", image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/c3j4zosy_IMG_1709.JPEG" },
  { label: "Home Gym Assembly", category: "Fitness Equipment", image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/mv9n5ylm_IMG_4179%202.JPG" },
  { label: "Recent Project", category: "Furniture Assembly", image: "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/jnnf80e3_IMG_3152%203.JPG" },
];

export const ABOUT_IMAGE = "https://customer-assets.emergentagent.com/job_home-solutions-local/artifacts/byodzta3_ChatGPT%20Image%20May%2017%2C%202026%2C%2012_34_03%20AM.png";

export const ABOUT = {
  title: "About Abid Home Solutions",
  paragraphs: [
    "Abid Home Solutions LLC is a local handyman and home services business serving Maryland, Washington, DC, and nearby areas. We help homeowners, renters, families, and busy professionals get home projects done without the stress.",
    "From TV mounting and furniture assembly to appliance installation, curtain installation, playground assembly, moving help, basic repairs, and general home maintenance, we focus on quality work, fair pricing, clear communication, and leaving your space clean when the job is complete.",
  ],
};
